import {Component} from '@angular/core';
import {ViewController} from "ionic-angular";
import {Observable} from "rxjs/Observable";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {ContactService} from "../../store/contact/contact.service";

/**
 * Generated class for the SelectKundeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'select-kunde',
  templateUrl: 'select-kunde.html'
})
export class SelectKundeComponent {

  text: string;
  public query: string = '';
  public searchTerm: string = '';
  public searchStrict: boolean = false;
  public queryProperty: string = 'company';
  public contacts: Observable<Array<any>>;

  constructor(private viewCtrl: ViewController,
              public contactService: ContactService,
              private loadingProvider: LoadingServiceProvider) {
    console.log('Hello SelectKundeComponent Component');
    this.text = 'Hello World';

    this.contacts = contactService.getAllByType(1);
  }

  public dismiss(customerId: number): void {
    this.loadingProvider.present();
    this.viewCtrl.dismiss(customerId);
  }

  public onInput(event: any): void {
    let searchTerm = event.target.value;
    if(searchTerm && searchTerm.length > 2){
      switch (true) {
        case (searchTerm.toLowerCase().startsWith('ort:') && searchTerm.length > 4):
          this.queryProperty = 'city';
          this.searchTerm = searchTerm.replace('ort:', '');
          this.searchStrict = true;
          break;
        case (searchTerm.toLowerCase().startsWith('vorname:') && searchTerm.length > 8):
          this.queryProperty = 'firstName';
          this.searchTerm = searchTerm.replace('vorname:', '');
          this.searchStrict = true;
          break;
        case (searchTerm.toLowerCase().startsWith('name:') && searchTerm.length > 5):
          this.queryProperty = 'lastName';
          this.searchTerm = searchTerm.replace('name:', '');
          this.searchStrict = true;
          break;
        case (searchTerm.toLowerCase().startsWith('plz:') && searchTerm.length > 4):
          this.queryProperty = 'zip';
          this.searchTerm = searchTerm.replace('plz:', '');
          this.searchStrict = true;
          break;
        default:
          this.queryProperty = 'company';
          this.searchTerm = searchTerm;
          this.searchStrict = false;
      }
    }else {
      this.queryProperty = 'company';
      this.searchTerm = '';
    }
  }

  public close(): void {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/select-kunde/select-kunde.ts